import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import { contactData } from '../data/contact';
import { homeData } from '../data/home';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: FaGithub,   url: contactData.social?.github   || homeData.social.github,   label: 'GitHub' },
    { icon: FaLinkedin, url: contactData.social?.linkedin || homeData.social.linkedin, label: 'LinkedIn' },
    { icon: FaEnvelope, url: homeData.social.email,                                    label: 'Email' },
  ].filter(s => s.url);

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-brand">
          <span className="footer-name">Affan Burney</span>
          <span className="footer-role">Cloud & DevOps Engineer</span>
        </div>

        <div className="footer-social">
          {socialLinks.map((s, i) => (
            <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
              <s.icon />
            </a>
          ))}
        </div>

        <div className="footer-copy">
          <span>© {currentYear} Affan Burney. All rights reserved.</span><br />
          <span>Built with React</span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
